import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { B2bunitService } from 'src/app/service/b2bunit/b2bunit.service';

@Component({
  selector: 'app-checkout-payment-details',
  templateUrl: './checkout-payment-details.component.html',
  styleUrls: ['./checkout-payment-details.component.scss'],
  standalone: false,
})
export class CheckoutPaymentDetailsComponent implements OnInit {
  b2bUnitServiceDetails$: Observable<any> = this.b2bUnitService.getB2BUnit();
  constructor(protected b2bUnitService: B2bunitService) {}

  ngOnInit() {}
}
